import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FilterBase } from 'src/app/shared/grid/filter-base';

@Component({
    selector: 'grid-assigned-to-id-filter',
    template: ` <mat-slide-toggle
        labelPosition="before"
        [ngModel]="isValueExistsInFilter"
        (change)="toggleFilter($event.checked)"
        [ngClass]="field + '-slideToggle-filter'">
        {{ title || '' }}
    </mat-slide-toggle>`,
    providers: [{ provide: FilterBase, useExisting: GridAssignedToIdFilterComponent }],
    styles: [
        `
            :host {
                box-sizing: border-box;
                display: inline-block;
                height: 28px;
                margin-left: 10px;
                position: relative;
                color: black;
            }
        `,
        'div { padding-top: 15px; }'
    ],
    standalone: true,
    imports: [MatSlideToggleModule, NgClass, FormsModule]
})
export class GridAssignedToIdFilterComponent extends FilterBase implements OnInit, OnChanges {
    isValueExistsInFilter = false;

    @Input() title: string;
    @Input() assignToId: number;
    @Input() assignToValue: boolean;
    @Input() assignToArraySet: any[];
    @Output() filterValueChanged = new EventEmitter<CompositeFilterDescriptor>();

    ngOnInit() {
        this.isValueExistsInFilter = Number(this.getLatestFilterValue()) > 0;

        if (Array.isArray(this.getLatestFilterValue())) {
            const val = this.getLatestFilterValue();
            this.isValueExistsInFilter = val.length > 0;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.isValueExistsInFilter = Number(this.getLatestFilterValue()) > 0;

            if (Array.isArray(this.getLatestFilterValue())) {
                const val = this.getLatestFilterValue();
                this.isValueExistsInFilter = val.length > 0;
            }
        }
    }

    public toggleFilter(isEnabled: boolean): void {
        if (!isEnabled) {
            this.removeFilter();
        } else if (this.assignToId) {
            this.updateFilter({
                field: this.field,
                operator: 'eq',
                value: this.assignToId
            });
        } else if (this.assignToArraySet) {
            this.updateFilter({
                field: this.field,
                operator: 'eq',
                value: this.assignToArraySet
            });
        } else if (this.assignToValue) {
            this.updateFilter({
                field: this.field,
                operator: 'eq',
                value: this.assignToValue
            });
        }
        this.filterValueChanged.emit(this.filter);
    }
}
